/**
 * Detects the user's preferred browser language from the list of available languages.
 * Returns undefined if no match is found.
 */
function getPreferredBrowserLanguage(availableLanguages: string[]): string | undefined {
    const shortLocales = navigator.languages.map((lang) => lang.toLocaleLowerCase().split("-")[0]);
    return shortLocales.find((lang) => availableLanguages.includes(lang));
}

/**
 * Resolves the initial UI locale based on priority:
 *   1. Persisted localStorage value
 *   2. Browser preferred language (if in available list)
 *   3. Tenant default language
 *   4. Fallback "en"
 */
export function resolveInitialLocale(options: {
    persistedLocale?: string;
    defaultLanguage: string;
    availableLanguages: string[];
}): string {
    const { persistedLocale, defaultLanguage, availableLanguages } = options;

    if (persistedLocale) {
        return persistedLocale;
    }

    const browserLang = getPreferredBrowserLanguage(availableLanguages);
    if (browserLang) {
        return browserLang;
    }

    return defaultLanguage || "en";
}
